import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import EditTyreCollection from '../../Jobs/dtn/EditTyreCollection';
import FormMultiSelect from '../../_shared/forms/FormMultiSelect';
import FormError from '../../_shared/forms/FormError';
import FormCheckbox from '../../_shared/forms/FormCheckbox';
import FormInputText from '../../_shared/forms/FormInputText';
import { isValidPostcode, POSTCODE_FORMAT_ERROR } from '../../../utils/Helpers';

export default class CreateInvoiceGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCustomers: this.props.invoiceGroup.selected_customers || [],
            name: this.props.invoiceGroup.name || '',
            po_number: this.props.invoiceGroup.po_number || '',
            email: this.props.invoiceGroup.email || '',
            use_custom_address: this.props.invoiceGroup.use_custom_address || false,
            address_line_1: this.props.invoiceGroup.address_line_1 || '',
            address_line_2: this.props.invoiceGroup.address_line_2 || '',
            city: this.props.invoiceGroup.city || '',
            county: this.props.invoiceGroup.county || '',
            postcode: this.props.invoiceGroup.postcode || '',
            errors: {},
            loading: false,
            xero_id: this.props.invoiceGroup.xero_id || '',
        };
    }

    handleChange = (e) => {
        let { value, name } = e.target;
        this.setState({
            [name]: value,
        });
    };

    handleCheckboxChange = (e) => {
        let { name } = e.target;
        this.setState({
            [name]: !this.state[name],
        });
    };

    handleMultiSelectChange = (value) => {
        this.setState({
            selectedCustomers: [...value],
        });
    };

    validateData = () => {
        let errors = {};
        if (!this.state.name) {
            errors.name = 'Name field is required';
        }

        if (!this.state.email) {
            errors.email = 'Email field is required';
        }

        if (!this.state.selectedCustomers.length) {
            errors.selectedCustomers = 'Please select at least one customer';
        }

        if (this.state.use_custom_address) {
            if (!this.state.address_line_1.length) {
                errors.address_line_1 = 'Address line 1 field is required';
            }

            if (!this.state.postcode) {
                errors.postcode = 'Postcode field is required';
            } else if (!isValidPostcode(this.state.postcode)) {
                errors.postcode = POSTCODE_FORMAT_ERROR;
            }
        }

        this.setState({
            errors: errors,
        });

        if (errors.postcode === POSTCODE_FORMAT_ERROR) {
            toastr.error(POSTCODE_FORMAT_ERROR);
        }

        if (Object.values(errors).some((error) => error !== POSTCODE_FORMAT_ERROR)) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.validateData()) {
            this.setState({
                loading: true,
            });

            let formData = new FormData();
            formData.append('name', this.state.name);
            formData.append('email', this.state.email);
            formData.append('po_number', this.state.po_number);
            formData.append('xero_id', this.state.xero_id);
            formData.append('customers', JSON.stringify(this.state.selectedCustomers));
            if (this.state.use_custom_address) {
                formData.append('address_line_1', this.state.address_line_1);
                formData.append('address_line_2', this.state.address_line_2);
                formData.append('city', this.state.city);
                formData.append('county', this.state.county);
                formData.append('postcode', this.state.postcode);
                formData.append('use_custom_address', this.state.use_custom_address);
            }

            if (Object.keys(this.props.invoiceGroup).length === 0) {
                axios
                    .post(this.props.route, formData)
                    .then((res) => {
                        toastr.success('Invoice group created');
                        this.setState({
                            loading: false,
                        });
                    })
                    .catch(() => {
                        toastr.error('Failed to create invoice group, please try again');
                        this.setState({
                            loading: false,
                        });
                    });
            } else {
                formData.append('_method', 'PATCH');
                axios
                    .post(this.props.route, formData)
                    .then((res) => {
                        toastr.success('Invoice group created');
                        this.setState({
                            loading: false,
                        });
                    })
                    .catch(() => {
                        toastr.error('Failed to create invoice group, please try again');
                        this.setState({
                            loading: false,
                        });
                    });
            }
        }
    };

    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                name="name"
                                value={this.state.name}
                                className="form-control"
                                placeholder="Name..."
                                onChange={this.handleChange}
                            />
                            {this.state.errors.name ? <FormError error={this.state.errors.name} /> : ''}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="po_number">PO number</label>
                            <input
                                type="text"
                                name="po_number"
                                value={this.state.po_number}
                                className="form-control"
                                placeholder="PO number..."
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="text"
                                name="email"
                                value={this.state.email}
                                className="form-control text-none"
                                placeholder="Email..."
                                onChange={this.handleChange}
                            />
                            {this.state.errors.email ? <FormError error={this.state.errors.email} /> : ''}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="xero_id">Xero ID</label>
                            <input
                                type="text"
                                name="xero_id"
                                value={this.state.xero_id}
                                className="form-control"
                                placeholder="Xero ID..."
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <FormMultiSelect
                                label="Customers"
                                options={this.props.customers}
                                classes="form-control"
                                prefixes={this.state.selectedCustomers}
                                handleMultiSelectChange={(value) => this.handleMultiSelectChange(value)}
                            />
                            {this.state.errors.selectedCustomers ? (
                                <FormError error={this.state.errors.selectedCustomers} />
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </div>

                {this.state.use_custom_address && (
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <FormInputText
                                    label="Address line 1"
                                    name="address_line_1"
                                    type="text"
                                    classes={
                                        this.state.errors.address_line_1 ? 'form-control is-invalid' : 'form-control'
                                    }
                                    value={this.state.address_line_1}
                                    handleChange={this.handleChange}
                                    error={this.state.errors.address_line_1}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <FormInputText
                                    label="Address line 2"
                                    name="address_line_2"
                                    type="text"
                                    classes={
                                        this.state.errors.address_line_2 ? 'form-control is-invalid' : 'form-control'
                                    }
                                    value={this.state.address_line_2}
                                    handleChange={this.handleChange}
                                    error={this.state.errors.address_line_2}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <FormInputText
                                    label="City"
                                    name="city"
                                    type="text"
                                    classes={this.state.errors.city ? 'form-control is-invalid' : 'form-control'}
                                    value={this.state.city}
                                    handleChange={this.handleChange}
                                    error={this.state.errors.city}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <FormInputText
                                    label="County"
                                    name="county"
                                    type="text"
                                    classes={this.state.errors.county ? 'form-control is-invalid' : 'form-control'}
                                    value={this.state.county}
                                    handleChange={this.handleChange}
                                    error={this.state.errors.county}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <FormInputText
                                    label="Postcode"
                                    name="postcode"
                                    type="text"
                                    classes={this.state.errors.postcode ? 'form-control is-invalid' : 'form-control'}
                                    value={this.state.postcode}
                                    handleChange={this.handleChange}
                                    error={this.state.errors.postcode}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col-md-12">
                        <FormCheckbox
                            name="use_custom_address"
                            label="Custom address"
                            checked={this.state.use_custom_address}
                            handleChange={this.handleCheckboxChange}
                            tooltipPosition="top"
                            tooltipTitle="Address will be displayed in generated invoice"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <button className="btn btn-cw-primary">
                            {this.state.loading ? (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            ) : (
                                'Save'
                            )}
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

if (document.getElementById('invoiceGroups')) {
    let element = document.getElementById('invoiceGroups');

    ReactDOM.render(
        <CreateInvoiceGroup
            customers={JSON.parse(element.dataset.customers)}
            invoiceGroup={JSON.parse(element.dataset.invoice_group)}
            route={element.dataset.route}
        />,
        element
    );
}
